import React from 'react';
import ResetPassword from './ResetPassword';

// This preview always shows the password reset form, regardless of token/email

const ResetPasswordPreview = () => {
  React.useEffect(() => {
    const fakeSearchParams = new URLSearchParams({
      token: 'demo-token',
      email: 'demo@email.com'
    });
    window.history.replaceState({}, '', `/reset-password-preview?${fakeSearchParams.toString()}`);
  }, []);
  return <ResetPassword />;
};

export default ResetPasswordPreview;
